import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { Title as FAQTitle } from '@spa/shared/components/FAQ/styles';
import { TooltipContainer } from '@spa/shared/components/Tooltip/styles';
import { Wrapper as Breadcrumbs } from '@spa/shared/components/CustomBreadcrumbs/styles';
import { Container as RegistrationNumberContainer } from '@spa/shared/components/RegistrationNumber/styles';
import { mediaMin } from '@spa/shared/theme';
export var Main = /*#__PURE__*/styled.main.withConfig({
  componentId: "sc-177ktdk-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;", " padding-bottom:", ";padding-inline:", ";@supports not (padding-inline:", "){padding-left:", ";padding-right:", ";}", "{width:100%;align-items:flex-start;}", "{flex-wrap:wrap;}", "{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(7, 'column');
}, function (props) {
  return props.theme.space(20);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, FAQTitle, Breadcrumbs, RegistrationNumberContainer, mediaMin.smallBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", " {\n        left: auto;\n        right: 0;\n        transform: none;\n      }\n    "])), TooltipContainer));
export var SectionPlaceholder = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-177ktdk-1"
})(["min-height:400px;"]);